import { SuiteType } from '../../floor-container/floor/item/item.model';

export interface Pagination {
  page: number;
  first: number;
  rows: number;
  pageCount: number;
}

export interface IssueField {
  value: number | string | boolean;
  error: boolean;
}

export interface IdentifiedIssue {
  name: string;
  recordType: SuiteType;
  id: number;
  floor: IssueField;
  suite: IssueField;
  spaceSize: IssueField;
  startDate: IssueField;
  endDate: IssueField;
  status: IssueField;
}

export interface CategorizedIssues {
  expired: IdentifiedIssue[];
  unknown: IdentifiedIssue[];
}

export interface PendingIssuesFormGroup {
  expired: boolean;
  unknown: boolean;
}
export const PENDING_ISSUES_HEADERS = [
  { field: 'name', header: 'pendingIssues.name' },
  { field: 'recordType', header: 'pendingIssues.recordType' },
  { field: 'id', header: 'pendingIssues.id' },
  { field: 'floor', header: 'pendingIssues.floorUnit' },
  { field: 'suite', header: 'pendingIssues.suite' },
  { field: 'spaceSize', header: 'pendingIssues.spaceSizeSF' },
  { field: 'startDate', header: 'pendingIssues.startedDate' },
  { field: 'endDate', header: 'pendingIssues.endDate' },
  { field: 'status', header: 'pendingIssues.status' },
];
